

import React from 'react';
import {  useGetSystemTemplatesQuery } from '../api/messageAPI';
import { ListGroup, Button } from "react-bootstrap";
import { LoaderComponent } from '../components/LoaderComponent';
import { MessageTemplate } from '../api/types/messages';
import { Icon } from '../components/ui/Icon';
import { MessageTemplateComponent } from '../components/messages';

interface PageProps {

}

interface TemplateListProps {
   templates: MessageTemplate[]
}


export const TemplatesList: React.FC<TemplateListProps> = (props) => {

   return <ListGroup>
      { props.templates.map( (template) =><MessageTemplateComponent template={template} key={template.id} preview={false}/>)}
   </ListGroup>

}

export const TemplatesPage: React.FC<PageProps> = (props) => {
   
   const {data, error, isLoading, refetch } = useGetSystemTemplatesQuery()

   const handleRefresh = ()=> {
      refetch();
   }

   return ( 
      <React.Fragment>
         <h1>Platform System messages templates</h1>
         <div className='m-1'><Button onClick={handleRefresh} size="sm"><Icon name='sync'/> Actualiser</Button></div>
        <LoaderComponent isLoading={isLoading} error={error} />
        { data ? <TemplatesList templates={data.templates} /> : ''}
      </React.Fragment>
   )
};

